<template>
	<div v-if="isSidebarDataFilled">
		<v-card class="sidebar">
			<v-list class="sidebar-list pa-0">
				<div class="sidebar-list__title-container">
					<span class="sidebar-list__title-container__text">
						{{sideBarTitle}}
					</span>
					<span class="sidebar-list__title-container__description mt-2">
						{{sideBarDescription}}
					</span>
				</div>
				<div
					class="sidebar-list__button-container mt-4">
                      <button
						  type="button"
						  :disabled="web.qr_code_generation_enabled === 0 || (!qrCodeStore.trim() && !qrCodeAndroid.trim())"
						  @click="openQrCodeModal"
						  class="sidebar-list__button-container__title">
						  {{!isModalOpen ? 'Click to Scan QR Code' : 'Scan to download the app'}}
					  </button>
					<div class="mt-2 d-flex">
						<div v-if="appStoreButtonTitle && qrCodeStore"
							 class="sidebar-list__button-container__android"
							 :class="{ 'active-button': isIosActive, 'single-button': buttonCount === 1 }">
							<button
								style="user-select: none;"
								@click="iosQrModal"
								type="button">
								{{appStoreButtonTitle}}
							</button>
						</div>
						<div
							 v-if="qrCodeAndroid && playMarketButtonTitle"
							 class="sidebar-list__button-container__ios"
							 :class="{ 'active-button': isAndroidActive, 'single-button': buttonCount === 1 }">
							<button
								style="user-select: none;"
								@click="androidQrModal"
								type="button">
								{{playMarketButtonTitle}}
							</button>
						</div>
					</div>
					<div v-if="isModalOpen"  class="sidebar-list__qr-code-container mt-4">
						<a :href="linkStore" target="_blank">
						<img
							class="sidebar-list__qr-code-container__image"
							:src="isQrCode ? qrCodeAndroidImage : qrCodeStoreImage"
							loading="lazy"
						/>
						</a>
					</div>
				</div>
			</v-list>
		</v-card>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from '@/components/Avatar'
import QRCode from 'qrcode'

export default {
	name: 'AdBanner',
	data(){
		return{
			isModalOpen: false,
			isQrCode:null,
			qrCodeStoreImage: '',
			qrCodeAndroidImage: '',
		}
	},
	components: {
		Avatar
	},
	methods: {
		async generateQrCode(url) {
			try {
				return await QRCode.toDataURL(url, { width: 128, margin: 2 })
			} catch (err) {
				console.error('error generating qr code:', err)
				return ''
			}
		},
		async openQrCodeModal() {
			this.isModalOpen = !this.isModalOpen;

			if (!this.isModalOpen) {
				this.isQrCode = null;
				return;
			}
			this.qrCodeStoreImage = this.qrCodeStore ? await this.generateQrCode(this.qrCodeStore) : '';
			this.qrCodeAndroidImage = this.qrCodeAndroid ? await this.generateQrCode(this.qrCodeAndroid) : '';

			if (this.qrCodeAndroid) {
				this.isQrCode = true;
			} else if (this.qrCodeStore) {
				this.isQrCode = false;
			} else {
				this.isQrCode = null;
			}
		},

		androidQrModal(){
			if (this.web.qr_code_generation_enabled === 0) {
				if (this.qrCodeAndroid) {
					window.open(this.qrCodeAndroid, '_blank');
				}
				return;
			}
			if (this.isQrCode || !this.isModalOpen) return
			this.isQrCode = true
		},
		iosQrModal() {
			if (this.web.qr_code_generation_enabled === 0) {
				if (this.qrCodeStore ) {
					window.open(this.qrCodeStore, '_blank');
				}
				return;
			}
			if (!this.isQrCode || !this.isModalOpen) return;
			this.isQrCode = false;
		},
	},
	computed: {
		...mapGetters('settings', ['web']),
		...mapGetters('auth', ['profile']),
		buttonCount() {
			let count = 0;
			if (this.qrCodeStore && this.appStoreButtonTitle) count++;
			if (this.qrCodeAndroid && this.playMarketButtonTitle) count++;
			return count;
		},
		linkStore(){
			return this.isQrCode ? this.web.sidebar_google_play_link : this.web.sidebar_store_link
		},
		playMarketButtonTitle(){
			if(!this.web) return ''
			return this.web.sidebar_google_play_button_title || ''
		},
		qrCodeAndroid(){
			if(!this.web) return ''
			return this.web.sidebar_google_play_link || ''
		},
		appStoreButtonTitle(){
			if(!this.web) return ''
			return this.web.sidebar_store_button_title || ''
		},
		qrCodeStore(){
			if(!this.web) return ''
			return this.web.sidebar_store_link || ''
		},
		sideBarDescription(){
			if(!this.web) return ''
			return this.web.sidebar_description || 'Get access to exclusive features like Chats, Notifications, QR Hub, and more in our mobile app!'
		},
		sideBarTitle(){
			if(!this.web) return ''
			return this.web.sidebar_title || 'Get more with our mobile app!'
		},
		isAndroidActive() {
			return this.isQrCode === true;
		},
		isIosActive() {
			return this.isQrCode === false;
		},
		isSidebarDataFilled() {
			return !!(
				this.web.sidebar_description.trim() ||
				this.web.sidebar_google_play_button_title.trim() ||
				this.web.sidebar_google_play_link.trim() ||
				this.web.sidebar_store_button_title.trim() ||
				this.web.sidebar_store_link.trim()
			);
		}
	},
}
</script>

<style scoped lang="scss">
.sidebar {
	max-width: 250px;
	width: 100%;
	border: 1px solid #e2e2e2;
	border-radius: 8px;
	padding: 16px;
	background-color: #ffffff!important;
}
.sidebar-list{
	&__title-container{
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		user-select: none;
		&__text{
			width: 100%;
			font-weight: 700;
			font-family: 'Inter', sans-serif;
			font-size: 18px;
			line-height: 100%;
			color: #002855;
			user-select: none;
		}
		&__description{
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			font-size: 13px;
			line-height: 1.1;
			color: #4a4a4a;
			letter-spacing: 0;
			text-align: left !important;
			user-select: none;
		}
	}
	&__button-container{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		user-select: none;
		.active-button {
			padding: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			color: #0055a3;
			line-height: 100%;
			font-size: 13px;
			border-bottom: 2px solid #0055a3;

		}
		&__title{
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 13px;
			line-height: 100%;
			color: #002855;
			cursor: pointer;
			user-select: none;
		}
		&__android{
			padding: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: 'Inter', sans-serif;
			font-size: 13px;
			line-height: 15.73px;
			font-weight: 500;
			color: #002855;
			border-right: 0.5px solid #e2e2e2;
			border-bottom: 1px solid #e2e2e2;
			width: 109px;
			user-select: none;
		}
		&__ios{
			padding: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: 'Inter', sans-serif;
			font-size: 13px;
			line-height: 15.73px;
			font-weight: 500;
			color: #002855;
			border-left: 0.5px solid #e2e2e2;
			border-bottom: 1px solid #e2e2e2;
			width: 109px;
			user-select: none;
		}
	}
	&__qr-code-container{
		min-height: 128px;
		display: flex;
		justify-content: center;
		align-items: center;
		user-select: none;
		&__image{
			width: 100%;
			max-width: 128px;
			height: 128px;
			user-select: none;
		}

	}
}
button:disabled {
	pointer-events: none;
	cursor: default;
}
.single-button {
	border-right: none !important;
	border-left: none !important;
}

</style>
